module.exports = __webpack_public_path__ + "static/media/activate_card.a1274676.png";